<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="900px"
    transition="dialog-transition"
  >
    <template #activator="{on}">
      <v-btn small rounded v-on="on">
        CARTS
        <v-badge color="teal" :content="TotalQtyInCart.toLocaleString()">
          <v-icon right>fas fa-cart-arrow-down</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title>
        <v-btn @click="ClearCart" icon color="error">
          <v-icon>fas fa-trash-alt</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        {{ `${SellType.toUpperCase()} CART LIST` }}
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="closeView">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :mobile-breakpoint="200"
          :headers="CartHeader"
          :items="getCarts"
          :items-per-page="getCarts.length"
          :item-class="item => RemainItem(item)"
        >
          <template #top>
            <v-toolbar
              flat
              dark
              :color="SellType == 'retail' ? 'error' : 'primary'"
            >
              <v-spacer></v-spacer>
              <strong> PRICE: {{ TotalPriceInCart.toLocaleString() }}</strong>
            </v-toolbar>
          </template>
          <template v-slot:[`item.InvName`]="{ item }">
            <BulkQty
              :SellType="SellType"
              :RemainQty="RemainQty(item)"
              :item="item"
            ></BulkQty>
          </template>
          <template v-slot:[`item.qty`]="{ item }">
            <QTY-Inc-Dec
              :item="item"
              :decrease="decrease"
              :increase="increase"
            />
          </template>
          <template v-slot:[`item.price`]="{ item }">
            {{ item.price.toLocaleString() }}
          </template>
          <template v-slot:[`item.total`]="{ item }">
            {{ (item.price * item.qty).toLocaleString() }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <strong class="mr-2"> QTY: {{ TotalQtyInCart }} </strong>
        <strong> PRICE: {{ TotalPriceInCart.toLocaleString() }}</strong>
        <v-spacer></v-spacer>

        <paymentForm
          v-if="TotalQtyInCart"
          :StoreInfo="StoreInfo"
          :SellType="SellType"
          :TotalPriceInCart="TotalPriceInCart"
        ></paymentForm>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    StoreInfo: { type: Object, default: () => ({}) },
    SellType: { type: String, required: true },
  },
  components: {
    paymentForm: () => import("../PaymentForm"),
    BulkQty: () => import("../bulkQty"),
    QTYIncDec: () => import("@/components/util/IncrementDecrement"),
  },
  data() {
    return {
      dialog: false,
      CartHeader: [
        {
          text: "Item",
          align: "left",
          value: "InvName",
          //   class: "green darken-3 white--text"
        },
        {
          text: "QTY",
          value: "qty",
          //   class: "green darken-3 white--text"
        },

        {
          text: "PRICE",
          value: "price",
          //   class: "green darken-3 white--text"
        },
        {
          text: "Total",
          value: "total",
          //   class: "green darken-3 white--text"
        },
      ],
    };
  },
  watch: {
    TotalQtyInCart(v) {
      if (v == 0 && this.dialog == true) this.dialog = false;
    },
  },
  computed: {
    ...mapGetters(["getCarts", "getGroupedProducts"]),
    TotalQtyInCart() {
      return this.getCarts.reduce((total, item) => {
        return (total += item.qty);
      }, 0);
    },

    TotalPriceInCart() {
      return this.getCarts.reduce((total, item) => {
        return (total += item.qty * item.price);
      }, 0);
    },
  },
  methods: {
    ClearCart() {
      this.$store.commit("RESET_CART");
    },
    closeView() {
      this.dialog = false;
    },
    RemainQty(item) {
      return this.getGroupedProducts.find(prod => prod.product == item.product);
    },
    RemainItem(item) {
      try {
        // console.log(item);
        let { qty, UnitQty } = this.getGroupedProducts.find(
          prod => item.product == prod.product
        );
        // console.log(qty);
        if (this.SellType == "retail") qty = qty * UnitQty;

        const remain = qty - item.qty;
        if (remain == 0) return "yellow darken-2 black--text";
        else if (remain < 0) return "error darken-1 white--text";
        else return "";
      } catch (error) {
        console.log(error);
      }
    },
    increase(item) {
      this.$store.commit("INCREASE_DECREASE_CART", {
        item,
        retail: this.SellType == "retail" ? true : false,
      });
    },
    decrease(item) {
      this.$store.commit("INCREASE_DECREASE_CART", { item, type: "dec" });
    },
  },
};
</script>
